export default {
  data() {
    return {
      noteStatuses: [
        { icon: 'fiber_manual_record', value: 0, label: 'No Status', color: 'grey lighten-3' },
        { icon: 'assessment', value: 1, label: 'Researching', color: 'blue' },
        { icon: 'warning', value: 2, label: 'Awaiting Review', color: 'orange' },
        { icon: 'check_circle', value: 3, label: 'Completed', color: 'green' }
      ]
    };
  }
};
